import action_button from "~/components/shared/actionButton"

export default {
  components: { action_button },
  mounted: function () {
    if (typeof this.$cookies.get("rgpdOptIn") === "undefined")
      this.$emit("input", true)
  },
  methods: {
    optInRgpd: function () {
      this.$cookies.set("rgpdOptIn", 1)
      this.$emit("input", false)
    },
  },
  props: {
    value: {
      type: Boolean,
      required: true,
    },
  },
}
